import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const ActivePassiveItemMainDetail = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Description")} fieldName={"description"} />
        </Col>
      </Row>

    </>
  );
};

export default ActivePassiveItemMainDetail;
